import { useNavigate } from "react-router-dom";
import { LargeButton } from "../_00Global/LargeButton";

export const _10BBody = (): JSX.Element => {
  const navigate = useNavigate();
  
  const handleWhatsAppClick = () => {
    window.open('https://api.whatsapp.com/send?phone=447462294653', '_blank', 'noopener,noreferrer');
  };

  const handleEmailClick = () => {
    navigate("/contactform");
  };

  return (
    <div className="flex w-full justify-center items-center">
      <div className="w-full max-w-[1440px] px-4 py-[30px]">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-[50px] lg:gap-[70px]">
          {/* WhatsApp Card */}
          <div 
            className="w-full max-w-[494px] flex items-center justify-center relative rounded-[39px] transition-transform duration-250 lg:hover:scale-105 cursor-pointer"
            onClick={handleWhatsAppClick}
          >
            <div className="flex flex-col w-full h-[636.78px] items-center justify-center gap-[27px] px-0 py-[50px] relative rounded-[40px] border border-dashed border-[var(--fy-grey)]">
              <img
                className="relative w-[60.06px] h-[60.63px]"
                alt="Left logo"
                src="/img/leftlogo.svg"
              />

              <div className="flex flex-col h-[90px] items-center justify-center px-[50px] py-0 relative self-stretch w-full">
                <div className="relative self-stretch mt-[-1.00px] [font-family:var(--contact-cardtitle-font-family)] [font-size:var(--contact-cardtitle-font-size)] [font-weight:var(--contact-cardtitle-font-weight)] text-[var(--fy-grey)] text-center [letter-spacing:var(--contact-cardtitle-letter-spacing)] [line-height:var(--contact-cardtitle-line-height)] [font-style:var(--contact-cardtitle-font-style)]">
                  Whatsapp
                </div>
              </div>

              <div className="flex flex-col h-7 items-center justify-center px-[50px] py-0 relative self-stretch w-full">
                <p className="relative self-stretch mt-[-1.00px] [font-family:var(--contact-cardsubtitle-font-family)] [font-size:var(--contact-cardsubtitle-font-size)] [font-weight:var(--contact-cardsubtitle-font-weight)] [font-style:var(--contact-cardsubtitle-font-style)] text-[var(--fy-grey)] text-center [letter-spacing:var(--contact-cardsubtitle-letter-spacing)] [line-height:var(--contact-cardsubtitle-line-height)]">
                  a reply within approx 5 minutes.
                </p>
              </div>

              <div className="flex flex-col w-full h-[28.89px] items-center justify-center relative">
                <div className="relative self-stretch mt-[-1.06px] [font-family:var(--section-divider-font-family)] [font-size:var(--section-divider-font-size)] [font-weight:var(--section-divider-font-weight)] text-[var(--fy-orange)] text-center [letter-spacing:var(--section-divider-letter-spacing)] [line-height:var(--section-divider-line-height)] [font-style:var(--section-divider-font-style)]">
                  ..........................................................
                </div>
              </div>

              <div className="flex flex-col h-[60px] items-center justify-center px-[50px] py-0 relative self-stretch w-full">
                <p className="relative self-stretch mt-[-1.00px] [font-family:var(--contact-carddescription-font-family)] [font-size:var(--contact-carddescription-font-size)] [font-weight:var(--contact-carddescription-font-weight)] text-[var(--fy-grey)] text-center [letter-spacing:var(--contact-carddescription-letter-spacing)] [line-height:var(--contact-carddescription-line-height)] [font-style:var(--contact-carddescription-font-style)]">
                  For a quicker reply, please message us on our
                  <br />
                  Business WhatsApp account below.
                </p>
              </div>

              <div className="flex flex-col w-full h-[28.89px] items-center justify-center relative">
                <div className="relative self-stretch mt-[-1.06px] [font-family:var(--section-divider-font-family)] [font-size:var(--section-divider-font-size)] [font-weight:var(--section-divider-font-weight)] text-[var(--fy-orange)] text-center [letter-spacing:var(--section-divider-letter-spacing)] [line-height:var(--section-divider-line-height)] [font-style:var(--section-divider-font-style)]">
                  ..........................................................
                </div>
              </div>

              <LargeButton text="WHATSAPP NOW" onClick={handleWhatsAppClick} />
            </div>
          </div>

          {/* Contact Card */}
          <div 
            className="w-full max-w-[494px] flex items-center justify-center relative rounded-[39px] transition-transform duration-250 lg:hover:scale-105 cursor-pointer"
            onClick={handleEmailClick}
          >
            <div className="flex flex-col w-full h-[636.78px] items-center justify-center gap-[27px] px-0 py-[50px] relative rounded-[40px] border border-dashed border-[var(--fy-grey)]">
              <img
                className="relative w-[74px] h-[49.04px]"
                alt="Right logo"
                src="/img/rightlogo.svg"
              />

              <div className="flex flex-col h-[90px] items-center justify-center px-[50px] py-0 relative self-stretch w-full">
                <div className="relative self-stretch mt-[-1.00px] [font-family:var(--contact-cardtitle-font-family)] [font-size:var(--contact-cardtitle-font-size)] [font-weight:var(--contact-cardtitle-font-weight)] text-[var(--fy-grey)] text-center [letter-spacing:var(--contact-cardtitle-letter-spacing)] [line-height:var(--contact-cardtitle-line-height)] [font-style:var(--contact-cardtitle-font-style)]">
                  Contact
                </div>
              </div>

              <div className="flex flex-col h-7 items-center justify-center px-[50px] py-0 relative self-stretch w-full">
                <p className="relative self-stretch mt-[-1.00px] [font-family:var(--contact-cardsubtitle-font-family)] [font-size:var(--contact-cardsubtitle-font-size)] [font-weight:var(--contact-cardsubtitle-font-weight)] [font-style:var(--contact-cardsubtitle-font-style)] text-[var(--fy-grey)] text-center [letter-spacing:var(--contact-cardsubtitle-letter-spacing)] [line-height:var(--contact-cardsubtitle-line-height)]">
                  a reply within approx 1-2 Hours.
                </p>
              </div>

              <div className="flex flex-col w-full h-[28.89px] items-center justify-center relative">
                <div className="relative self-stretch mt-[-1.06px] [font-family:var(--section-divider-font-family)] [font-size:var(--section-divider-font-size)] [font-weight:var(--section-divider-font-weight)] text-[var(--fy-orange)] text-center [letter-spacing:var(--section-divider-letter-spacing)] [line-height:var(--section-divider-line-height)] [font-style:var(--section-divider-font-style)]">
                  ..........................................................
                </div>
              </div>

              <div className="flex flex-col h-[60px] items-center justify-center px-[50px] py-0 relative self-stretch w-full">
                <p className="relative self-stretch mt-[-1.00px] [font-family:var(--contact-carddescription-font-family)] [font-size:var(--contact-carddescription-font-size)] [font-weight:var(--contact-carddescription-font-weight)] text-[var(--fy-grey)] text-center [letter-spacing:var(--contact-carddescription-letter-spacing)] [line-height:var(--contact-carddescription-line-height)] [font-style:var(--contact-carddescription-font-style)]">
                  Answer some short questions about your day,
                  <br />
                  and we will get back to you within a few hours.
                </p>
              </div>

              <div className="flex flex-col w-full h-[28.89px] items-center justify-center relative">
                <div className="relative self-stretch mt-[-1.06px] [font-family:var(--section-divider-font-family)] [font-size:var(--section-divider-font-size)] [font-weight:var(--section-divider-font-weight)] text-[var(--fy-orange)] text-center [letter-spacing:var(--section-divider-letter-spacing)] [line-height:var(--section-divider-line-height)] [font-style:var(--section-divider-font-style)]">
                  ..........................................................
                </div>
              </div>

              <LargeButton text="EMAIL FORM" onClick={handleEmailClick} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 